<template>
  <div class="global-customer-service">
    <!-- 客服悬浮按钮 -->
    <img 
      v-if="!showModal" 
      src="@/assets/images/kefu.png" 
      alt="客服" 
      class="service-button" 
      @mouseenter="handleMouseEnter" 
    />

    <!-- 联系我们弹窗 -->
    <div v-if="showModal" class="contact-modal">
      <div class="modal-header">
        <span class="modal-title">联系我们</span>
        <button class="close-button" @click="showModal = false">
          <svg class="close-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12L5 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>

      <div class="modal-content">
        <div class="contact-item">
          <div class="contact-label">电话咨询</div>
          <div class="contact-value">400-900-6269</div>
          <div class="contact-time">工作日：9:00-18:00（北京时间）</div>
        </div>

        <div class="contact-item">
          <div class="contact-label">扫码咨询</div>
          <div class="qr-code">
            <img src="@/assets/images/kefuwechat.png" alt="客服二维码" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

const showModal = ref(true) // 默认显示弹窗

// 鼠标移入客服图标时显示弹窗
const handleMouseEnter = () => {
  showModal.value = true
}
</script>

<style scoped lang="less">
.global-customer-service {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
}

.service-button {
  width: 64px;
  height: 64px;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
}

.contact-modal {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 250px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  animation: slideUp 0.3s ease-out;
}

.modal-header {
  background: #0675FF;
  color: white;
  height: 46px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .modal-title {
    font-size: 16px;
    font-weight: 500;
  }

  .close-button {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
    position: relative;
    left: 10px;
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    .close-icon {
      width: 16px;
      height: 16px;
    }
  }
}

.modal-content {
  padding: 18px;
}

.contact-item {
  margin-bottom: 20px;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }

  .contact-label {
    font-weight: bold;
    font-size: 18px;
    color: #000000;
    margin-bottom: 8px;
    margin-top: 3px;
  }

  .contact-value {
    font-weight: bold;
    font-size: 18px;
    color: #000000;
    margin-bottom: 4px;
  }

  .contact-time {
    font-size: 12px;
    color: #999;
    margin-bottom: 10px;
  }

  .qr-code {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    
    img {
      width: 120px;
      height: 120px;
      border-radius: 0;
      // border: 2px solid #e5e5e5;
    }
  }
}



@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .global-customer-service {
    bottom: 24px;
    right: 24px;
  }

  .service-button {
    width: 50px;
    height: 50px;
  }

  .contact-modal {
    bottom: 24px;
    right: 24px;
    width: 250px;
  }

  .modal-content {
    padding: 10px;
  }

  .contact-item .qr-code img {
    width: 100px;
    height: 100px;
  }
}
</style>
